// if a login page is framed, we need to pop out of it on redirect
export const getWindow = () => (window.top ? window.top : window);

export const getLocation = () => {
  const { location } = getWindow();
  return location;
};
